const Dashboard = () =>
  import(
    /* webpackChunkName: "ProjectDashboard" */ `@/components/rapsotec/projects/project/Dashboard.vue`
  );
const TopicOrRisk = () =>
  import(
    /* webpackChunkName: "ProjectAvis" */ `@/components/rapsotec/projects/project/TopicOrRisk.vue`
  );
const AIPortal = () =>
  import(/* webpackChunkName: "AIPortal" */ `@/components/rapsotec/projects/project/AIPortal.vue`);
const Configuration = () =>
  import(
    /* webpackChunkName: "ProjectConfiguration" */ `@/components/rapsotec/projects/project/Configuration.vue`
  );
const Details = () =>
  import(
    /* webpackChunkName: "ProjectDetail" */ `@/components/rapsotec/projects/project/Details.vue`
  );
const Reports = () =>
  import(
    /* webpackChunkName: "ProjectReports" */ `@/components/rapsotec/projects/project/Reports.vue`
  );
const Users = () =>
  import(/* webpackChunkName: "ProjectUsers" */ `@/components/rapsotec/projects/project/Users.vue`);
const ProjectUser = () =>
  import(
    /* webpackChunkName: "ProjectUser" */ `@/components/rapsotec/projects/project/ProjectUser.vue`
  );
const DocumentV2 = () =>
  import(
    /* webpackChunkName: "ProjectDocumentV2" */ `@/components/rapsotec/projects/project/DocumentV2.vue`
  );
import TopicOrRiskChildrens from "./project/TopicOrRisk";
import AIPortalChildrens from "./project/AIPortal";
import ConfigurationChildrens from "./project/Configuration";
import DetailsChildrens from "./project/Details";
import ReportsChildrens from "./project/Reports";
import DocumentsV2Childrens from "./project/DocumentV2";
import { useProjectStore } from "@/store/project.js";

export default [
  {
    path: "",
    name: "project",
    component: Dashboard,
    beforeEnter: async (to, from, next) => {
      const projectNumber = to.params.projectId;

      // Validate projectId before making API calls (fixes Sentry issue #19710)
      if (!projectNumber || typeof projectNumber !== "string" || !projectNumber.trim()) {
        console.error("[ProjectChildrens beforeEnter] Invalid projectId:", projectNumber);
        // Redirect to projects list or show error
        next({ name: "projectsList" });
        return;
      }

      try {
        const projectStore = useProjectStore();
        const projectInfos = await projectStore.fetchProjectEntity(projectNumber);
        if (projectInfos?.entity === "SECU") {
          next({
            name: "projectDetailCase",
            params: { projectId: projectNumber },
          });
        } else {
          next();
        }
      } catch (error) {
        console.error(error);
        // Consider redirecting on error as well
        next();
      }
    },
    meta: {
      allowExternal: true,
    },
  },
  {
    path: "configuration",
    component: Configuration,
    children: ConfigurationChildrens,
  },
  {
    path: "document",
    component: DocumentV2,
    children: DocumentsV2Childrens,
  },
  {
    // I.B 21/07/26 URL héritée conservée pour les favoris : /documentv2(/…) -> /document(/…)
    path: "documentv2/:pathMatch(.*)*",
    redirect: (to) => to.fullPath.replace("/documentv2", "/document"),
  },
  {
    path: ":topicOrRisk(avis|risques)",
    name: "topicOrRisk",
    component: TopicOrRisk,
    children: TopicOrRiskChildrens,
    meta: {
      allowExternal: true,
    },
  },
  {
    path: "validation-avis",
    name: "aiPortal",
    redirect: { name: "pmrTopicAnalysisPlans" },
    component: AIPortal,
    children: AIPortalChildrens,
  },
  {
    path: "details",
    component: Details,
    children: DetailsChildrens,
  },
  {
    path: "reports",
    component: Reports,
    children: ReportsChildrens,
  },
  {
    path: "users",
    name: "projectUsers",
    component: Users,
  },
  {
    path: "project-user",
    name: "projectUser",
    component: ProjectUser,
    meta: {
      allowExternal: true,
      allowExternalNoAccess: true,
    },
  },
];
